var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountDeleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 161,
    viewBox: "0 0 244 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.977 13.9995L22.7905 48.9089L74.1939 125.752L126.38 90.843L74.977 13.9995Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.414 87.2056L98.8187 90.8707L72.8745 87.1312L73.4699 83.4661L99.414 87.2056Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.349 74.1311L90.0699 74.666L85.9443 100.21L82.2188 99.6706L86.349 74.1311Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4517 41.6662C62.4889 41.722 57.261 45.2848 50.7726 49.6243C44.2843 53.9639 38.9959 57.4383 38.9587 57.3825C38.9215 57.3267 44.1494 53.7639 50.6378 49.4243C57.1261 45.0848 62.4145 41.6104 62.4517 41.6662Z",
    fill: "#E0E0E0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6426 36.8476C81.6799 36.9034 72.9822 42.7871 62.2194 49.9825C51.452 57.1825 42.6985 62.9732 42.6613 62.9174C42.624 62.8615 51.3171 56.9825 62.0845 49.7778C72.8473 42.5778 81.6054 36.7871 81.6426 36.8429V36.8476Z",
    fill: "#E0E0E0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4888 42.5964C85.526 42.6522 76.8284 48.5359 66.0656 55.7312C55.2981 62.9312 46.5447 68.7219 46.5074 68.6661C46.4702 68.6103 55.1633 62.7312 65.9307 55.5266C76.6935 48.3266 85.4516 42.5359 85.4888 42.5917V42.5964Z",
    fill: "#E0E0E0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3355 48.3498C89.3727 48.4056 80.6751 54.2893 69.9123 61.4847C59.1448 68.6847 50.3913 74.4754 50.3541 74.4195C50.3169 74.3637 59.0099 68.4847 69.7774 61.28C80.5402 54.08 89.2983 48.2893 89.3355 48.3451V48.3498Z",
    fill: "#E0E0E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1866 54.1034C93.2238 54.1593 84.5261 60.043 73.7633 67.2383C62.9959 74.4383 54.2424 80.229 54.2052 80.1732C54.168 80.1174 62.861 74.2383 73.6285 67.0337C84.3912 59.8337 93.1494 54.043 93.1866 54.0988V54.1034Z",
    fill: "#E0E0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.893 63.0878L82.4465 147.646L80.293 158.716L190.088 158.176C195.014 158.153 199.381 153.776 200.967 147.279L220.437 67.446C221.642 62.5111 219 57.3809 215.26 57.3809L104.135 57.4971C101.679 57.4971 99.5348 59.7902 98.893 63.0878Z",
    fill: "#B4DAFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.893 63.0878L82.4465 147.646L80.293 158.716L190.088 158.176C195.014 158.153 199.381 153.776 200.967 147.279L220.437 67.446C221.642 62.5111 219 57.3809 215.26 57.3809L104.135 57.4971C101.679 57.4971 99.5348 59.7902 98.893 63.0878Z",
    fill: "#1485FD"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M231.066 44.6933L183.244 19.1157L145.581 89.5324L193.404 115.11L231.066 44.6933Z",
    fill: "#F5F5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.222 93.0821L182.189 94.1193L174.487 72.8309L177.519 71.7891L185.222 93.0821Z",
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M189.873 77.8076L190.98 80.8634L169.835 88.1053L168.729 85.0495L189.873 77.8076Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M204.896 46.3939C204.858 46.4637 200.007 43.9427 194.063 40.7614C188.114 37.58 183.328 34.9474 183.365 34.8776C183.403 34.8079 188.254 37.3288 194.198 40.5102C200.142 43.6916 204.933 46.3241 204.896 46.3939Z",
    fill: "#E0E0E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M216.37 59.0636C216.333 59.1334 208.305 54.9148 198.444 49.6404C188.579 44.366 180.612 40.0311 180.649 39.9613C180.686 39.8915 188.714 44.1101 198.579 49.3892C208.44 54.6636 216.407 58.9985 216.37 59.0683V59.0636Z",
    fill: "#E0E0E0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M213.552 64.3334C213.514 64.4032 205.487 60.1846 195.626 54.9101C185.761 49.6357 177.793 45.3008 177.831 45.2311C177.868 45.1613 185.896 49.3799 195.761 54.659C205.621 59.9334 213.589 64.2683 213.552 64.3381V64.3334Z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.733 69.6032C210.696 69.6729 202.668 65.4543 192.807 60.1799C182.942 54.9055 174.975 50.5706 175.012 50.5009C175.049 50.4311 183.077 54.6497 192.942 59.9288C202.803 65.2032 210.77 69.5381 210.733 69.6078V69.6032Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M207.914 74.873C207.877 74.9427 199.849 70.7241 189.989 65.4497C180.124 60.1753 172.156 55.8404 172.193 55.7706C172.231 55.7009 180.259 59.9195 190.124 65.1985C199.984 70.473 207.952 74.8078 207.914 74.8776V74.873Z",
    fill: "#E0E0E0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M179.558 141.92L167.935 48.2414C167.46 44.4042 164.4 41.5391 160.791 41.553L135.298 41.6367C133.409 41.6414 131.6 42.4461 130.26 43.8693L118.158 56.7344L47.2604 57.1065C42.9301 57.1298 39.5999 61.2274 40.172 65.8367L50.9674 152.418C51.4464 156.251 54.4976 159.111 58.1022 159.102L181.66 158.86C195.423 159.144 196.735 155.083 196.735 155.083C180.963 158.576 179.558 141.934 179.558 141.925V141.92Z",
    fill: "#B4DAFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.283 123.172L122.116 127.646L90.0229 98.7715L94.1904 94.2971L126.283 123.172Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.367 93.3064L124.977 97.4506L95.9347 128.637L91.3301 124.497L120.367 93.3064Z",
    fill: "#FF0000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDeleted);
export default __webpack_public_path__ + "static/media/AccountDeleted.57676303d76d7afe4d11414f999f60b3.svg";
export { ForwardRef as ReactComponent };